import { QueryClient } from 'react-query'
import { ApiError } from './ApiError'
import { isPrivateRoute, logout } from './auth'

// Create QueryClient with error handling for 40x responses
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchOnMount: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.statusCode === 401) {
          return false
        }
        return failureCount < 4
      },
      onError: (error) => {
        if (
          error instanceof ApiError &&
          error.statusCode === 401 &&
          isPrivateRoute(window.location.pathname)
        ) {
          logout(window.location.pathname)
        }
      },
    },
    mutations: {
      onError: (error) => {
        if (error instanceof ApiError && error.statusCode === 401) {
          logout(window.location.pathname)
        }
      },
    },
  },
})
